module.exports = __webpack_public_path__ + "static/media/21.1fdd148f.svg";